import { BranchError } from 'branch-sdk';

import { BranchEvent } from '.';

import { logger } from '../services';
import { isWebview } from '../../../util/window/getDevice';

import { BRANCH_API_KEY } from '../configs/config';

export default class BranchService {
  instance?: any;

  userId?: string;

  async getInstance() {
    if (!this.instance) {
      this.instance = (await import('branch-sdk')).default;
      this.instance.init(BRANCH_API_KEY);
    }

    return this.instance;
  }

  setUserId(userId: string) {
    this.userId = userId;
  }

  async logEvent<EventData, ContentItems>(event: BranchEvent<EventData, ContentItems>) {
    if (!process.browser || !BRANCH_API_KEY) {
      return;
    }

    if (isWebview()) {
      // 브런치 이벤트는 네이티브 앱에서 직접 전송합니다. 따라서 Webview에서는 따로 보내지
      // 않습니다.
      return;
    }

    const instance = await this.getInstance();
    await new Promise<void>((resolve) => instance
      .setIdentity(this.userId, resolve));

    /**
     * Register commerce events, content events, user lifecycle events and custom events via `logEvent()`
     *
     * @param event
     * @param [event_data_and_custom_data]
     * @param [content_items]
     * @param [customer_event_alias]
     * @param [callback]
     */
    instance.logEvent(
      event.getName(),
      event.getEventData(),
      event.getContentItems(),
      undefined,
      (err: BranchError) => {
        if (err) {
          logger.error(err);
        }
      },
    );
    logger.debug(event, `[BRANCH] Sent event: ${event.getName()}`);
  }

  async openAppDownloadBanner() {
    const instance = await this.getInstance();

    const linkData = {
      campaign: 'Organic',
      channel: 'Kurly_MobileWeb',
      feature: 'Organic',
      stage: 'Kurly_MobileWeb',
      tags: [location.href],
      alias: '',
      data: {
        custom_bool: true,
        custom_int: Date.now(),
        custom_string: '',
        $og_title: '마켓컬리 :: 내일의 장보기, 마켓컬리',
        $og_description: 'Love Food, Love Life. 마켓컬리! 당일 수확 채소, 과일, 맛집 음식까지 내일 아침 문 앞에서 만나요!',
        $og_image_url: 'https://res.kurly.com/images/marketkurly/logo/logo_sns_marketkurly.jpg',
      },
    };

    instance.setBranchViewData(linkData);
    instance.closeJourney();
    instance.track('pageview');
  }
}
